<template>
  <div>
    <main-navbar v-if="isAuth" />
    <landing-page-navbar v-else />
    <div
      class="page-view"
      :style="isAuth ? { top: '0px' } : { left: '0', width: '100%', top: '0' }"
    >
      <div class="pricing-page">
        <vue-content-loading v-if="loading" :height="60" :speed="1">
          <rect x="0" y="0" rx="4" ry="4" width="100%" height="60" />
        </vue-content-loading>
        <div v-else>
          <p v-if="packageList.length < 1" class="question-tab__error">
            <img
              :src="require('@/assets/hrVenue/search-big.svg')"
              alt="icon search"
              height="45"
            />
            {{ resource["label.NoResult"] }}
          </p>
          <b-tabs v-else>
            <b-tab
              v-for="[key, value] in Object.entries(
                packageList.mainPackageList
              )"
              :key="key"
              class="pricing-tabs"
            >
              <template #title>
                <div class="d-flex flex-column align-items-center gap-1">
                  <h3 class="d-flex gap-1 align-items-center">
                    <svg
                      v-if="key === 'yearly'"
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="20"
                      viewBox="0 0 21 20"
                      fill="none"
                    >
                      <path
                        d="M10.4999 14.5996L13.9583 16.6913C14.5916 17.0746 15.3666 16.508 15.1999 15.7913L14.2833 11.858L17.3416 9.20798C17.8999 8.72464 17.5999 7.80798 16.8666 7.74964L12.8416 7.40798L11.2666 3.69131C10.9833 3.01631 10.0166 3.01631 9.73327 3.69131L8.15827 7.39964L4.13327 7.74131C3.39994 7.79964 3.09994 8.71631 3.65827 9.19964L6.71661 11.8496L5.79994 15.783C5.63327 16.4996 6.40827 17.0663 7.0416 16.683L10.4999 14.5996Z"
                        fill="#FF8D06"
                      />
                    </svg>
                    {{ resource[`pricingTabName.${key}`] }}
                  </h3>
                  <p>{{ resource[`pricingTabDescription.${key}`] }}</p>
                </div>
              </template>
              <div>
                <p v-if="isMobile && key === 'yearly'" class="yearly-info-text">{{resource[`pricingFeaturesDesc`]}}</p>
                <PricingTabItemMobile
                  v-if="isMobile"
                  :items="value"
                  :trialPackage="packageList.trialPackage"
                  :type="key"
                  :paymentIsActive="paymentIsActive"
                  :currentPackage="currentPackage"
                />
                <PricingTabItem
                  v-else
                  :items="value"
                  :trialPackage="packageList.trialPackage"
                  :type="key"
                  :paymentIsActive="paymentIsActive"
                  :currentPackage="currentPackage"
                />
              </div>
            </b-tab>
          </b-tabs>
          <div class="custom-product" :style="isAuth && { 'margin-top': '24px' }">
            <h3>{{ resource["pricing.customProductName"] }}</h3>
            <p>{{ resource["pricing.customProductDescription"] }}</p>
            <a @click="contactUsClick" class="custom-product__link cursor-pointer">
              {{ resource["pricing.customProductButton"] }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import AccountService from '@/services/account';
import hrvenueService from '../services/hrvenue.service';
import MainNavbar from './layout/MainNavbar';
import LandingPageNavbar from './layout/LandingPageNavbar';
import { showNotification } from '../static/helpers';
import PricingTabItem from './hrVenue/pricing/pricingTabItem';
import PricingTabItemMobile from './hrVenue/pricing/pricingTabItemMobile';

export default {
  name: 'Pricing',

  metaInfo: {
    meta: [
      {
        name: 'description',
        content: 'Visit our pricing page to see our plans and pricing.',
      },
      {
        hreflang: 'x-default',
        rel: 'alternate',
        href: 'https://company.interview.co/pricing',
      },
      {
        hreflang: 'tr',
        rel: 'alternate',
        href: 'https://company.interview.co/tr/pricing',
      },
      {
        hreflang: 'de',
        rel: 'alternate',
        href: 'https://company.interview.co/de/pricing',
      },
      {
        hreflang: 'fr',
        rel: 'alternate',
        href: 'https://company.interview.co/fr/pricing',
      },
      {
        hreflang: 'es',
        rel: 'alternate',
        href: 'https://company.interview.co/es/pricing',
      },
    ],
  },

  jsonld: {
    '@context': 'http://schema.org',
    '@type': 'WebApplication',
    name: 'Interview.co',
    url: 'https://interview.co/',
    '@id': 'https://company.interview.co/login',
    browserRequirements: ['requires HTML5 support', 'requires JavaScript'],
    sameAs: 'https://interview.co/',
    applicationCategory: 'BusinessApplication',
    permissions: 'may run only with an active internet connection',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5',
      reviewCount: '100',
    },
    offers: {
      '@type': 'AggregateOffer',
      offeredBy: {
        '@type': 'Organization',
        name: 'interview.co',
      },
      highPrice: '2990.00',
      lowPrice: '49.00',
      offerCount: '6',
      priceCurrency: 'EUR',
      priceSpecification: [
        {
          '@type': 'UnitPriceSpecification',
          price: '49.00',
          priceCurrency: 'EUR',
          name: 'interview.co Silver monthly subscription',
          referenceQuantity: {
            '@type': 'QuantitativeValue',
            value: '1',
            unitCode: 'MON',
          },
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '99.00',
          priceCurrency: 'EUR',
          name: 'interview.co Gold monthly subscription',
          referenceQuantity: {
            '@type': 'QuantitativeValue',
            value: '1',
            unitCode: 'MON',
          },
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '299.00',
          priceCurrency: 'EUR',
          name: 'interview.co Platinum monthly subscription',
          referenceQuantity: {
            '@type': 'QuantitativeValue',
            value: '1',
            unitCode: 'MON',
          },
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '490.00',
          priceCurrency: 'EUR',
          name: 'interview.co Silver annualy subscription',
          referenceQuantity: {
            '@type': 'QuantitativeValue',
            value: '1',
            unitCode: 'ANN',
          },
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '990.00',
          priceCurrency: 'EUR',
          name: 'interview.co Gold annualy subscription',
          referenceQuantity: {
            '@type': 'QuantitativeValue',
            value: '1',
            unitCode: 'ANN',
          },
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '2990.00',
          priceCurrency: 'EUR',
          name: 'interview.co Platinum annualy subscription',
          referenceQuantity: {
            '@type': 'QuantitativeValue',
            value: '1',
            unitCode: 'ANN',
          },
        },
      ],
    },
    creator: {
      '@type': 'Organization',
      '@id': 'https://interview.co/#organization',
      url: 'https://interview.co/',
      name: 'interview.co',
      logo: {
        '@type': 'ImageObject',
        url: 'https://interview.co/images/interview-logo.svg',
        width: '362',
        height: '54',
      },
    },
  },

  components: {
    PricingTabItem,
    MainNavbar,
    LandingPageNavbar,
    PricingTabItemMobile,
  },

  data() {
    return {
      loading: true,
      packageList: [],
      paymentIsActive: true,
      isMobile: false,
    };
  },

  async created() {
    try {
      if (this.isAuth) {
        const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

        const stripeIsActive = await hrvenueService.getSettingKey(
          'FeatureManagement:Stripe',
        );
        if (stripeIsActive === 'False') {
          this.$router.push({ name: 'HomeView', params: { lang } });
          return;
        }
        const stripePaymentIsActive = await hrvenueService.getSettingKey(
          'FeatureManagement:StripePaymentIsActive',
        );
        this.paymentIsActive = stripePaymentIsActive === 'True';
        if (this.paymentIsActive) {
          await fetch('https://ipapi.co/json/')
            .then((response) => {
              response.json().then((jsonData) => {
                if (jsonData.country_code === 'TR') {
                  this.paymentIsActive = false;
                }
              });
            });
        }
        const companyPackage = await hrvenueService.getCompanyPackage();
        if (companyPackage !== null) {
          this.setShowPricingButton(false);
        }
      } else {
        await fetch('https://ipapi.co/json/')
          .then((response) => {
            response.json().then((jsonData) => {
              if (jsonData.country_code === 'TR') {
                this.paymentIsActive = false;
              }
            });
          });
      }
      const result = await hrvenueService.getPackages();
      this.packageList = result;
      if (this.isAuth) {
        const key = await hrvenueService.getSettingKey(
          'ExternalApplications:Stripe:PublishableKey',
        );
        this.setPublishableKey(key);
      }
      this.loading = false;
    } catch (error) {
      // console.log(error);
      this.loading = false;
    }

    if (this.$route.query && this.$route.query.s === 'false') {
      showNotification(
        this.resource['Label.Error'],
        this.resource['pricing.errorMessage'],
        'error',
      );
    }
  },

  mounted() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  methods: {
    ...mapMutations(['setPublishableKey', 'setShowPricingButton']),
    handleResize() {
      this.isMobile = window.innerWidth <= 1048;
    },

    contactUsClick() {
      dataLayer.push({
        event: 'ga4_event',
        event_name: 'contact_us_click',
        page_type: 'pricing',
        site_type: 'interview',
      });
      const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

      this.$router.push({ name: 'ContactUs', params: { lang } });
    },
  },

  computed: {
    isAuth() {
      return AccountService.checkAuth();
    },
    currentPackage() {
      if (this.packageList) {
        const currentPackage = {
          activeMainPackage: this.packageList.activeMainPackage,
          activeMainPackageId: this.packageList.activeMainPackageId,
          hasMainPackage: this.packageList.hasMainPackage,
          trialPackageIsUsed: this.packageList.trialPackageIsUsed,
          activeMainPackageInterval: this.packageList.activeMainPackageInterval,
        };
        return currentPackage;
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/style/starter.scss";

.new-page-view {
  .page-view {
    top: 24px !important;
    padding-top: 0;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      top: 0 !important;
      margin-top: 24px;
    }
  }
}

.pricing-page {
  max-width: 1152px;
  padding: 16px;
  margin: 0 auto;
}

.tabs {
  :deep(.tab-content) {
    margin-top: 24px;
  }

  :deep(.nav.nav-tabs) {
    outline: none;
    border: 4px solid #e4e4e4;
    width: fit-content;
    border-radius: 50px;
    margin: 0 auto;
    background: #e4e4e4;

    .nav-item {
      h3 {
        color: #353535;
        font-family: Ubuntu;
        font-size: 20px;
        font-weight: 700;
        line-height: 28px;
      }
      p {
        color: #353535;
        font-family: Ubuntu;
        font-size: 10px;
        font-weight: 400;
        line-height: 16px;
        text-transform: uppercase;
      }
      a {
        width: 176px;
        padding: 10px 16px;
        background: none;
        border: none;
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0;
        background: #e4e4e4;
        border-radius: 50px;

        @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
          width: 167px;
        }

        &.active {
          background: #fff !important;
          border-radius: 50px;
          transition: background 0.5s ease-in-out;

          &:after {
            display: none;
          }
          &.black {
            font-weight: $bold;
            color: $dusk;
            @include box-shadow(inset 0 -3px 0 0 $dusk);
          }
        }
        &.disabled {
          opacity: 0.5;
        }
        &.deactive {
          font-weight: $normal;
          color: $warm-grey;
          -webkit-box-shadow: none;
          box-shadow: none;
        }
        &:focus {
          outline: 0 !important;
        }
      }
      &:focus {
        outline: 0 !important;
      }
    }
  }
  &.center {
    .nav.nav-tabs {
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;
    }
  }
}

.yearly-info-text {
  color: #878787;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  text-align: center;
  width: 100%;
  margin: 18px 0;
}

:deep(.tab-content > .active) {
  transition: all 0.5s ease-in-out;
}

.custom-product {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 36px;
  background: #ffffff;
  border: 1px solid #e4e4e4;
  border-radius: 20px;
  margin-top: 16px;

  @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 24px;
  }

  h3 {
    font-family: Ubuntu;
    font-weight: 700;
    font-size: 24px;
    line-height: 25px;
    color: #353535;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      line-height: 32px;
    }
  }

  p {
    flex-grow: 1;
    font-family: Ubuntu;
    font-weight: 400;
    font-size: 16px;
    line-height: 25px;
    color: #353535;
    margin-left: 24px;

    @media only screen and (max-width: map-get($grid-breakpoints, "lg")) {
      margin-left: 0;
      margin-bottom: 24px;
      margin-top: 4px;
    }
  }

  &__link {
    font-family: "Ubuntu", sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 22px;
    border: 1px solid #353535;
    border-radius: 50px;
    font-family: Ubuntu;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    letter-spacing: 0.46px;
    white-space: nowrap;
  }
}
</style>
